var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:true});exports.StyleSheet=void 0;var _reactNative=require("react-native");
var _engine=_interopRequireDefault(require("./Api/engine"));

var StyleSheet={
create:function create(styles){
if(_engine.default==='engine-rn-next')return styles;
return _reactNative.StyleSheet.create(styles);
}};exports.StyleSheet=StyleSheet;
//# sourceMappingURL=stylesheet.js.map